/** @jsx jsx */
import PropTypes from 'prop-types'
import {jsx, css} from '@emotion/react'

import Button from '../../button'
import StartpageLogo from '../../../images/startpage-logo-new.svg'

const LogoButton = ({onCtaClick}) => {
    return (
        <div
            css={css`
                padding: 1rem;
                margin: auto;
                @media (max-width: 600px) {
                    height: 140px;
                }
            `}
        >
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    margin: auto;
                    height: 61px;
                    @media (max-width: 600px) {
                        flex-direction: column;
                    }
                `}
            >
                <div
                    css={css`
                        border-right: 2px solid #ebecf2;
                        padding-right: 1rem;
                        margin-right: 1rem;
                        @media (max-width: 600px) {
                            padding: 0;
                            margin: 0;
                            border-right: none;
                        }
                    `}
                >
                    <StartpageLogo
                        css={css`
                            width: 160px;
                        `}
                    />
                </div>
                <div>
                    <Button
                        text="Search In Private"
                        overrideStyles="
                            button {
                                margin: 0;
                            }
                        "
                        onClick={onCtaClick}
                    />
                </div>
            </div>
        </div>
    )
}

LogoButton.propTypes = {
    onCtaClick: PropTypes.func,
}

LogoButton.defaultProps = {
    onCtaClick: () => {},
}

export default LogoButton
